import styled from "styled-components";
import colors from "assets/styles/colors";

export default styled.div`
    align-items: center;
    display: flex;

    .text {
        flex-direction: column;
        display: flex;

        p {
            margin: 0;
            font-weight: bolder;
            font-size: 16px;
        }

        .ignoredInfo {
            color: #777777;
            font-size: 12px;
            margin-top: -5px;
        }
    }

    .icon {
        display: flex;

        justify-content: center;
        align-items: center;

        margin-right: 10px;

        svg {
            font-size: 20px;
        }
    }

    &.blue {
        color: ${colors.textTeal};
        .icon {
            color: ${colors.textTeal};
        }
    }
    &.grey {
        color: #777777;
        .icon {
            color: #777777;
        }
    }
    &.orange {
        color: ${colors.accentOrange};
        .icon {
            color: ${colors.accentOrange};
        }
    }
    &.red {
        color: ${colors.accentRed};
        .icon {
            color: ${colors.accentRed};
        }
    }
    &.green {
        color: ${colors.accentGreen};
        .icon {
            color: ${colors.accentGreen};
        }
    }
`;
